import React from 'react'
import { useTranslation } from 'react-i18next'

import { IconBack } from '../../../../Ui/Icons'

type Props = {
  pointsLength: number | undefined
  currentStep: number
  setCurrentStep: (step: number) => void
  onCloseRoute: () => void
}

export function InfoWindowControlSection(props: Props) {
  const { pointsLength, onCloseRoute, currentStep, setCurrentStep } = props
  const { t } = useTranslation('info')

  function next() {
    if (pointsLength && pointsLength === currentStep + 1) {
      return onCloseRoute()
    }
    setCurrentStep(currentStep + 1)
  }

  return (
    <div className={`route__control`}>
      <button onClick={onCloseRoute} className={`to_routes`}>
        <IconBack />
        {t('routes')}
      </button>
      <div className="control__flex">
        {currentStep > 0 && (
          <button className="prev" onClick={() => setCurrentStep(currentStep - 1)}>
            TO #{currentStep}
          </button>
        )}
        <button className="next" onClick={next}>
          {pointsLength && pointsLength === currentStep + 1 ? 'Finish' : 'Next'}
        </button>
      </div>
    </div>
  )
}
